import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Directive({
    selector: '[autoFocus]',
    standalone: true
})

export class AutoFocusDirective {
    @Input('formGroup') formGroup !: FormGroup;
    constructor(private el: ElementRef) { }

    @HostListener('submit') onSubmit() {
        if (this.formGroup.valid) return;

        this.formGroup.markAllAsTouched();

        const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');
        if (invalidControl) invalidControl.focus();
    }
} 